import Vue from 'vue'
import Router from 'vue-router'
const je = require('json-encrypt')

// Containers
const TheContainer = () => import('@/containers/TheContainer')

// Views
const Dashboard = () => import('@/views/Dashboard')



// Views - Components

const Forms = () => import('@/views/base/Forms')


// Views - Pages
const Page404 = () => import('@/views/pages/Page404')
const Page500 = () => import('@/views/pages/Page500')
const Login = () => import('@/views/pages/Login')
const Register = () => import('@/views/pages/Register')

const userGuard = (to, from, next) => {

  let user = window.localStorage.getItem("user");
  let user_permissions = window.localStorage.getItem("user_permissions");
  
  if (user == null || user == undefined) {    
    next('/')
  }else{
    user = JSON.parse(JSON.parse(je.decrypt(user)));
    if (user.api_token.length != 60) {
        next('/')
    }else{
      let isAuthenticated = false;
      if (user_permissions == null || user_permissions == undefined) {
        next({ name: 'Page404' })
      }else{
        user_permissions = JSON.parse(JSON.parse(je.decrypt(user_permissions)));
        if (user_permissions.indexOf(to.name) > -1) isAuthenticated = true
      }
      if (!isAuthenticated) next({ name: 'Page404' })
      else next()
      
    }
  }
  

}


Vue.use(Router)

export default new Router({
  mode: 'history', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'active',
  scrollBehavior: () => ({ y: 0 }),
  routes: configRoutes()
})

function configRoutes () {
  return [
    {
      path: '/',
      redirect: '/',
      name: 'Login',
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: '/',
          name: 'LoginPage',
          component: Login
        },
      ]
    },
    {
      path: '/inicio',
      redirect: '/inicio/inicio',
      name: 'Home',
      component: TheContainer,
      children: [
        {
          path: 'inicio',
          name: 'Dashboard',
          component: Dashboard,          
        },
        {
          path: '404',
          name: 'Page404',
          component: Page404,
        },
        {
          path: '500',
          name: 'Page500',
          component: Page500,
        },
      ]
    },

    {
      path: '/usuario',
      redirect: '/usuario/listar',
      name: 'Usuario',
      component: TheContainer,
      children: [
        {
          path: 'listar',
          name: 'UserList',
          component: ()=>import('@/views/user/List'),
          beforeEnter: userGuard
        },
        {
          path: 'nuevo',
          name: 'UserAdd',
          component: ()=>import('@/views/user/Add'),
          beforeEnter: userGuard
          
        },
        {
          path: 'editar/:id_user',
          name: 'UserEdit',
          component: ()=>import('@/views/user/Edit'),
          props: true,
          beforeEnter: userGuard
          
        },
        {
          path: 'ver/:id_user',
          name: 'UserView',
          component: ()=>import('@/views/user/View'),
          props: true,
          beforeEnter: userGuard
          
        },  
      ]
    },

    {
      path: '/tipo-usuario',
      redirect: '/tipo-usuario/listar',
      name: 'TipoUsuario',
      component: TheContainer,
      children: [
        {
          path: 'listar',
          name: 'UserTypeList',
          component: ()=>import('@/views/usertype/List'),
          beforeEnter: userGuard
        },
        {
          path: 'nuevo',
          name: 'UserTypeAdd',
          component: ()=>import('@/views/usertype/Add'),
          beforeEnter: userGuard
          
        },
        {
          path: 'editar/:id_user_type',
          name: 'UserTypeEdit',
          component: ()=>import('@/views/usertype/Edit'),
          props: true,
          beforeEnter: userGuard
          
        },
        {
          path: 'ver/:id_user_type',
          name: 'UserTypeView',
          component: ()=>import('@/views/usertype/View'),
          props: true,
          beforeEnter: userGuard
          
        },  
      ]
    },


    {
      path: '/cliente',
      redirect: '/cliente/listar',
      name: 'Cliente',
      component: TheContainer,
      children: [
        {
          path: 'listar',
          name: 'ClientList',
          component: ()=>import('@/views/client/List'),
          beforeEnter: userGuard
        },
        {
          path: 'nuevo',
          name: 'ClientAdd',
          component: ()=>import('@/views/client/Add'),
          beforeEnter: userGuard
          
        },
        {
          path: 'editar/:id_client',
          name: 'ClientEdit',
          component: ()=>import('@/views/client/Edit'),
          props: true,
          beforeEnter: userGuard
          
        },
        {
          path: 'ver/:id_client',
          name: 'ClientView',
          component: ()=>import('@/views/client/View'),
          props: true,
          beforeEnter: userGuard
          
        },  
      ]
    },


    {
      path: '/proveedor',
      redirect: '/proveedor/listar',
      name: 'Proveedor',
      component: TheContainer,
      children: [
        {
          path: 'listar',
          name: 'ProviderList',
          component: ()=>import('@/views/provider/List'),
          beforeEnter: userGuard
        },
        {
          path: 'nuevo',
          name: 'ProviderAdd',
          component: ()=>import('@/views/provider/Add'),
          beforeEnter: userGuard
          
        },
        {
          path: 'editar/:id_provider',
          name: 'ProviderEdit',
          component: ()=>import('@/views/provider/Edit'),
          props: true,
          beforeEnter: userGuard
          
        },
        {
          path: 'ver/:id_provider',
          name: 'ProviderView',
          component: ()=>import('@/views/provider/View'),
          props: true,
          beforeEnter: userGuard
          
        },  
      ]
    },


    {
      path: '/categoria',
      redirect: '/categoria/listar',
      name: 'Categoria',
      component: TheContainer,
      children: [
        {
          path: 'listar',
          name: 'CategoryList',
          component: ()=>import('@/views/category/List'),
          beforeEnter: userGuard
        },
        {
          path: 'nuevo',
          name: 'CategoryAdd',
          component: ()=>import('@/views/category/Add'),
          beforeEnter: userGuard
          
        },
        {
          path: 'editar/:id_category',
          name: 'CategoryEdit',
          component: ()=>import('@/views/category/Edit'),
          props: true,
          beforeEnter: userGuard
          
        },
        {
          path: 'ver/:id_category',
          name: 'CategoryView',
          component: ()=>import('@/views/category/View'),
          props: true,
          beforeEnter: userGuard
          
        },  
      ]
    },
    {
      path: '/producto',
      redirect: '/producto/listar',
      name: 'Producto',
      component: TheContainer,
      children: [
        {
          path: 'listar',
          name: 'ProductList',
          component: ()=>import('@/views/product/List'),
          beforeEnter: userGuard
        },
        {
          path: 'nuevo',
          name: 'ProductAdd',
          component: ()=>import('@/views/product/Add'),
          beforeEnter: userGuard
          
        },
        {
          path: 'editar/:id_product',
          name: 'ProductEdit',
          component: ()=>import('@/views/product/Edit'),
          props: true,
          beforeEnter: userGuard
          
        },
        {
          path: 'ver/:id_product',
          name: 'ProductView',
          component: ()=>import('@/views/product/View'),
          props: true,
          beforeEnter: userGuard
          
        },  
      ]
    },


    {
      path: '/comprobante',
      redirect: '/comprobante/listar',
      name: 'Comprobante',
      component: TheContainer,
      children: [
        {
          path: 'listar',
          name: 'VoucherList',
          component: ()=>import('@/views/voucher/List'),
          beforeEnter: userGuard
        },
        {
          path: 'nuevo',
          name: 'VoucherAdd',
          component: ()=>import('@/views/voucher/Add'),
          beforeEnter: userGuard
          
        },
        {
          path: 'editar/:id_voucher',
          name: 'VoucherEdit',
          component: ()=>import('@/views/voucher/Edit'),
          props: true,
          beforeEnter: userGuard
          
        },
        {
          path: 'ver/:id_voucher',
          name: 'VoucherView',
          component: ()=>import('@/views/voucher/View'),
          props: true,
          beforeEnter: userGuard
          
        },  
      ]
    },

  
    {
      path: '/compra',
      redirect: '/compra/listar',
      name: 'Compra',
      component: TheContainer,
      children: [
        {
          path: 'listar',
          name: 'ShoppingList',
          component: ()=>import('@/views/shopping/List'),
          beforeEnter: userGuard
        },
        {
          path: 'nuevo',
          name: 'ShoppingAdd',
          component: ()=>import('@/views/shopping/Add'),
          beforeEnter: userGuard
          
        },
        {
          path: 'editar/:id_shopping',
          name: 'ShoppingEdit',
          component: ()=>import('@/views/shopping/Edit'),
          props: true,
          beforeEnter: userGuard
          
        },
        {
          path: 'ver/:id_shopping',
          name: 'ShoppingView',
          component: ()=>import('@/views/shopping/View'),
          props: true,
          beforeEnter: userGuard
          
        },  
      ]
    },


    {
      path: '/venta',
      redirect: '/venta/listar',
      name: 'Venta',
      component: TheContainer,
      children: [
        {
          path: 'listar',
          name: 'SaleList',
          component: ()=>import('@/views/sale/List'),
          beforeEnter: userGuard
        },
        {
          path: 'nuevo',
          name: 'SaleAdd',
          component: ()=>import('@/views/sale/Add'),
          beforeEnter: userGuard
          
        },
        {
          path: 'editar/:id_sale',
          name: 'SaleEdit',
          component: ()=>import('@/views/sale/Edit'),
          props: true,
          beforeEnter: userGuard
          
        },
        {
          path: 'ver/:id_sale',
          name: 'SaleView',
          component: ()=>import('@/views/sale/View'),
          props: true,
          beforeEnter: userGuard
          
        },  
      ]
    },


    {
      path: '/tipo-habitacion',
      redirect: '/tipo-habitacion/listar',
      name: 'TipoHabitacion',
      component: TheContainer,
      children: [
        {
          path: 'listar',
          name: 'TypeRoomList',
          component: ()=>import('@/views/type-room/List'),
          beforeEnter: userGuard
        },
        {
          path: 'nuevo',
          name: 'TypeRoomAdd',
          component: ()=>import('@/views/type-room/Add'),
          beforeEnter: userGuard
          
        },
        {
          path: 'editar/:id_type_room',
          name: 'TypeRoomEdit',
          component: ()=>import('@/views/type-room/Edit'),
          props: true,
          beforeEnter: userGuard
          
        },
        {
          path: 'ver/:id_type_room',
          name: 'TypeRoomView',
          component: ()=>import('@/views/type-room/View'),
          props: true,
          beforeEnter: userGuard
          
        },  
      ]
    },



    {
      path: '/habitacion',
      redirect: '/habitacion/listar',
      name: 'Habitacion',
      component: TheContainer,
      children: [
        {
          path: 'listar',
          name: 'RoomList',
          component: ()=>import('@/views/room/List'),
          beforeEnter: userGuard
        },
        {
          path: 'nuevo',
          name: 'RoomAdd',
          component: ()=>import('@/views/room/Add'),
          beforeEnter: userGuard
          
        },
        {
          path: 'editar/:id_room',
          name: 'RoomEdit',
          component: ()=>import('@/views/room/Edit'),
          props: true,
          beforeEnter: userGuard
          
        },
        {
          path: 'ver/:id_room',
          name: 'RoomView',
          component: ()=>import('@/views/room/View'),
          props: true,
          beforeEnter: userGuard
          
        },  
      ]
    },



    {
      path: '/control-habitacion',
      redirect: '/control-habitacion/listar',
      name: 'Control Habitacion',
      component: TheContainer,
      children: [
        {
          path: 'listar',
          name: 'RoomControlList',
          component: ()=>import('@/views/room-control/List'),
          beforeEnter: userGuard
        },
        {
          path: 'nuevo',
          name: 'RoomControlAdd',
          component: ()=>import('@/views/room-control/Add'),
          beforeEnter: userGuard
          
        },
        {
          path: 'editar/:id_room',
          name: 'RoomControlEdit',
          component: ()=>import('@/views/room-control/Edit'),
          props: true,
          beforeEnter: userGuard
          
        },
        {
          path: 'ver/:id_room',
          name: 'RoomControlView',
          component: ()=>import('@/views/room-control/View'),
          props: true,
          beforeEnter: userGuard
          
        },  
      ]
    },




  ]
}


